import Reports from './reports';
import API from './api';
import { defaultReportQueryParams } from '../utils/reports';

const api = new API();

const URL_SKAN_SUMMARY_REPORTING_DATA = '/api/get_skan_summary_report_data';

let instance = null;

class SkanSummary {
    constructor() {
        if (!instance) {
            instance = this;
        }

        return instance;
    }

    runQuery(params, options) {
        return new Promise((resolve, reject) => {
            api.getJson(URL_SKAN_SUMMARY_REPORTING_DATA, {
                method: 'POST',
                credentials: 'include',
                body: {
                    ...defaultReportQueryParams,
                    ...params,
                },
                cache: false,
                unique: true,
                ...options,
            })
                .then(response => {
                    if (response.status !== 0) {
                        reject(Reports.ERROR_RUN_QUERY);
                    }
                    resolve(response.value);
                })
                .catch(reject);
        });
    }
}

export default SkanSummary;
